export const CLEAN_QUERY = "CLEAN_QUERY";
export const START_SEARCH = "START_SEARCH";
export const FINISH_SEARCH = "FINISH_SEARCH";
export const UPDATE_SELECTION = "UPDATE_SELECTION";
